import {
  Box,
  FormLabel,
  MenuItem,
  Pagination,
  Select,
  type SelectChangeEvent,
} from '@mui/material'
import type { ChangeEvent } from 'react'
import { SEARCH_RESULTS_PER_PAGE } from '../../constants'
import { useSearch } from '../../hooks/useSearch'
import { useAppSelector } from '@/redux/hooks'
import { DirectPageInput } from '../DirectPageInput'

export const CardPagination = () => {
  const { searchResults, selectors, updateMetaOptions } = useSearch()
  const { details } = searchResults
  const options = useAppSelector(selectors.selectMetaOptions)
  const mediaSizes = SEARCH_RESULTS_PER_PAGE

  const currentPage = Math.floor(options.skip / options.size) + 1
  const pageCount = Math.max(1, Math.ceil(details.totalCount / options.size))

  const handleSizeChange = (event: SelectChangeEvent<number>) => {
    if (event.target.value) {
      updateMetaOptions({ size: event.target.value as number })
    }
  }

  const handlePageChange = (
    _event: ChangeEvent<unknown>,
    page: number,
  ): void => {
    updateMetaOptions({ skip: (page - 1) * options.size })
  }

  const handleDirectPageSubmit = (page: number): void => {
    updateMetaOptions({ skip: (page - 1) * options.size })
  }

  const start = Math.min(options.skip + 1, details.totalCount)
  const end = Math.min(options.skip + options.size, details.totalCount)

  const totalCountDisplay = details.exceedsMax
    ? `${details.totalCount.toLocaleString()}+`
    : details.totalCount.toLocaleString()

  return (
    <>
      <Box fontSize={14}>
        <FormLabel sx={{ fontSize: 14 }}>Results per page:&nbsp;</FormLabel>
        <Select
          variant="standard"
          size="small"
          value={options.size}
          onChange={handleSizeChange}
          sx={{ fontSize: 14 }}
        >
          {mediaSizes.map((i) => (
            <MenuItem key={i} value={i}>
              {i}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <Box fontSize={14}>
        {start.toLocaleString()}-{end.toLocaleString()} of {totalCountDisplay}
      </Box>
      <DirectPageInput
        currentPage={currentPage}
        pageCount={pageCount}
        onPageSubmit={handleDirectPageSubmit}
      />
      <Box>
        <Pagination
          page={currentPage}
          count={pageCount}
          onChange={handlePageChange}
        />
      </Box>
    </>
  )
}
